module.exports = __webpack_public_path__ + "img/A61-20190408_08.2f01c256.jpg";